import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import ClassetInputText from '../../../../../classetComponents/classetInputText';
import { ADJUSTMENT_RULES } from '../constants';

class OldFeeInfoDialog extends Component {
    renderHeader = () => {
        const { onBackClick } = this.props;
        
        return (
            <div className='flex align-items-center text-center text-black-alpha-80'>
                <span 
                    className="back-arrow-icon"
                    onClick={onBackClick}
                    style={{ cursor: 'pointer' }}
                >
                    <i className="pi pi-arrow-left" style={{ fontSize: '1.5rem', color: '#333' }}></i>
                </span>
                <h3 style={{ margin: 0, flex: 1 }}>Category Change Summary</h3>
            </div>
        );
    };

    renderFooter = () => {
        const { totalClosingAdvance, totalClosingDueAmt, onNewFeeTypesClick, onCancel } = this.props;
        
        return (
            <div className="flex flex justify-content-center my-3">
                {totalClosingAdvance >= totalClosingDueAmt && (
                    <Button
                        className="formAddButton px-4 mr-2"
                        style={{ backgroundColor: '#007bff', color: '#fff', borderRadius: '10px' }}
                        onClick={onNewFeeTypesClick}
                    >
                        <p className="formAddButtonText">New Fee Types</p>
                    </Button>
                )}
                <Button 
                    className="cancelButtonn" 
                    style={{ width: "164px", height: "48px" }} 
                    onClick={onCancel}
                >
                    <p className="cancelButtonnText">Cancel</p>
                </Button>
            </div>
        );
    };

    closingAmountBodyTemplate = (rowData, options) => {
        const { adjustmentRuleNo, onClosingAmountChange } = this.props;
        
        if (adjustmentRuleNo === ADJUSTMENT_RULES.MANUAL_ADJUSTMENT) {
            return (
                <ClassetInputText
                    className='border-round-md no-border custom-field-focused border-none pl-3 body-medium'
                    height="48px"
                    width='150px'
                    value={rowData?.closingAmount || 0}
                    keyfilter={"num"}
                    onChange={e => {
                        let val = e.target.value;
                        if (/^0\d+/.test(val)) {
                            val = val.replace(/^0+/, '');
                        }
                        onClosingAmountChange(val, options.rowIndex);
                    }}
                />
            );
        }
        
        return <span>{parseFloat(rowData?.closingAmount || 0).toFixed(2)}</span>;
    };

    amountPaidBodyTemplate = (rowData) => {
        const adjustedPaidAmount = parseFloat(rowData?.closingAmount || 0) - parseFloat(rowData?.closingDueAmt || 0);
        const actualAmountPaid = parseFloat(rowData?.amountPaid || 0);
        const finalAmountPaid = Math.min(adjustedPaidAmount, actualAmountPaid);
        
        return <span>{finalAmountPaid.toFixed(2)}</span>;
    };

    dueAmountBodyTemplate = (rowData) => {
        const closingAmount = parseFloat(rowData?.closingAmount || 0);
        const actualPaid = parseFloat(rowData?.amountPaid || 0);
        const displayDueAmt = Math.max(0, closingAmount - Math.min(closingAmount, actualPaid));
        
        return <span>{displayDueAmt.toFixed(2)}</span>;
    };

    renderSummarySection = () => {
        const { oldFeeInfo, totalClosingDueAmt, totalClosingAdvance } = this.props;
        
        return (
            <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                <div className="flex gap-6">
                    <div className="flex align-items-center gap-2">
                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>
                            Closing Amount:
                        </span>
                        <span className="text-xl">
                            ₹{oldFeeInfo?.feeInfo?.reduce((acc, curr) => acc + (curr.closingAmount || 0), 0).toFixed(2)}
                        </span>
                    </div>
                    <div className="flex align-items-center gap-2">
                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>
                            Amount Paid:
                        </span>
                        <span className="text-xl">
                            ₹{oldFeeInfo?.feeInfo?.reduce((acc, curr) => acc + (curr.closingAmount - curr.closingDueAmt), 0).toFixed(2)}
                        </span>
                    </div>
                    <div className="flex align-items-center gap-2">
                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>
                            Due Amount:
                        </span>
                        <span className="text-xl">
                            {totalClosingAdvance >= totalClosingDueAmt
                                ? "₹0.00"
                                : `₹${(totalClosingDueAmt - totalClosingAdvance).toFixed(2)}`}
                        </span>
                    </div>
                    <div className="flex align-items-center gap-2">
                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>
                            Advance:
                        </span>
                        <span className="text-xl">
                            ₹{totalClosingAdvance >= totalClosingDueAmt
                                ? (totalClosingAdvance - totalClosingDueAmt).toFixed(2)
                                : "0.00"}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    renderAdvanceInfo = () => {
        const { totalClosingAdvance, totalClosingDueAmt } = this.props;
        
        return (
            <div className="mt-2">
                {totalClosingAdvance >= totalClosingDueAmt ? (
                    <div className="flex align-items-center mt-2">
                        <i className="pi pi-info-circle mx-2"></i>
                        <span className="info-text" style={{ fontSize: "14px", color: "#268900" }}>
                            Sufficient advance is available to clear all dues. The remaining advance balance after settlement will be ₹{(totalClosingAdvance - totalClosingDueAmt).toFixed(2)}.
                        </span>
                    </div>
                ) : (
                    <div className="flex align-items-center mt-2">
                        <i className="pi pi-exclamation-triangle mx-2" style={{ color: '#BF0031' }}></i>
                        <span className="info-text" style={{ fontSize: "14px", color: '#BF0031' }}>
                            Available advance is not sufficient to clear all dues. Please ensure the pending amount of ₹{(totalClosingDueAmt - totalClosingAdvance).toFixed(2)} is paid before proceeding.
                        </span>
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { visible, onHide, oldFeeInfo } = this.props;

        return (
            <Dialog
                visible={visible}
                style={{ width: '80%', height: "80%" }}
                header={this.renderHeader()}
                showGridlines
                draggable={false}
                closable={true}
                onHide={onHide}
                footer={this.renderFooter()}
            >
                <div className="card datatable-crud-demo">
                    <DataTable
                        className='dataTableValuesText'
                        value={oldFeeInfo?.feeInfo}
                    >
                        <Column 
                            field="feeType" 
                            header="Fee Type" 
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="totalFee" 
                            header="Actual Fee"
                            body={(rowData) => <span>{parseFloat(rowData?.totalFee || 0).toFixed(2)}</span>}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="amountPaid" 
                            header="Actual Amount Paid"
                            body={(rowData) => <span>{parseFloat(rowData?.amountPaid || 0).toFixed(2)}</span>}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="closingAmount" 
                            header="Amount To Be Deducted"
                            body={this.closingAmountBodyTemplate}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="" 
                            header="Amount Paid"
                            body={this.amountPaidBodyTemplate}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center'
                        />
                        <Column 
                            field="closingDueAmt" 
                            header="Due"
                            body={this.dueAmountBodyTemplate}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                    </DataTable>
                </div>
                {this.renderSummarySection()}
                {this.renderAdvanceInfo()}
            </Dialog>
        );
    }
}

export default OldFeeInfoDialog;
